import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '@/services/auth-service';

export const ProtectedRoute = ({ children }) => {
    const user = useUser();
    const location = useLocation();

    // Show loading state while checking authentication
    if (user === undefined || user === '') {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="w-8 h-8 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
            </div>
        );
    }

    // Redirect to log in if not authenticated
    if (!user) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }

    return children;
};

// Component for routes that should only be accessible when NOT authenticated
export const PublicOnlyRoute = ({ children }) => {
    const user = useUser();
    const location = useLocation();

    if (user) {
        // Redirect to home or the page they came from if they're already logged in
        const destination = location.state?.from?.pathname || '/home';
        return <Navigate to={destination} replace />;
    }

    return children;
};
